const id_sales_quotationMitra = {
    message: {
        reject_title: 'Apakah anda yakin untuk membatalkan penawaran ?',
        reject_text: 'Masukan alasan membatalkan penawaran',
    },

    error: {
        create: 'Gagal membuat penawaran',
        edit: 'Gagal mengubah penawaran',

        reject: 'Gagal membatalkan penawaran',
        approve: 'Gagal mengkonfirmasi penawaran',
        done: 'Gagal menyelesaikan penawaran',
    },

    success: {
        create: 'Berhasil membuat penawaran',
        edit: 'Berhasil mengubah penawaran',

        reject: 'Berhasil membatalkan penawaran',
        approve: 'Berhasil mengkonfirmasi penawaran',
        done: 'Berhasil menyelesaikan penawaran',
    },
}

export default id_sales_quotationMitra;